import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import moment from "moment";
import numberToWord from "../../utils/numberToWord";
const keys = require("../../config/keys");

class TuitionFeesReceipt extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        {this.props.tuitionFeesDetails.map((item, eIndex) => {
          return (
            <table
              border={0}
              cellPadding={0}
              cellSpacing={0}
              style={{
                border: "1px solid #444",
                width: "100%"
              }}
              key={eIndex}
              className="tuitionFeestable"
            >
              <tbody>
                <tr>
                  <td colSpan={2}>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          {item.OrgLogo !== undefined &&
                          item.OrgLogo !== null ? (
                            <td
                              style={{
                                padding: "10px",
                                width: "135px",
                                height: "115px",
                                display: "block",
                                position: "relative"
                              }}
                            >
                              <img
                                src={keys.ServicePath + item.OrgLogo}
                                alt="logo"
                                className="printlogo-img"
                              />
                            </td>
                          ) : (
                            <td />
                          )}

                          <td
                            style={{
                              padding: "10px",
                              width: "80%"
                            }}
                          >
                            <table
                              style={{
                                verticalAlign: "top",
                                width: "100%"
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    style={{
                                      verticalAlign: "top",
                                      textAlign: "center"
                                    }}
                                  >
                                    <h3
                                      style={{
                                        margin: 0,
                                        padding: 0,
                                        float: "left",
                                        textAlign: "center",
                                        display: "block",
                                        width: "100%"
                                      }}
                                    >
                                      <span className="text-uppercase">
                                        {item.OrgName}
                                      </span>
                                    </h3>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      verticalAlign: "top",
                                      textAlign: "center"
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: 0,
                                        padding: 0,
                                        textAlign: "center",
                                        width: "100%",
                                        fontSize: "11pt",
                                        display: "inline-block"
                                      }}
                                    >
                                      <strong>{item.Address}</strong>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    style={{
                                      verticalAlign: "top",
                                      textAlign: "center"
                                    }}
                                  >
                                    <strong
                                      style={{
                                        padding: "2px",
                                        fontSize: "10pt",
                                        display: "block"
                                      }}
                                    >
                                      Tuition Fees Receipt
                                      {item.IsCancel ? " (Cancelled)" : ""}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>

                          {item.OrgTypeId !== 1 &&
                          item.StudentPhoto !== undefined &&
                          item.StudentPhoto !== null ? (
                            <td
                              style={{
                                padding: "10px",
                                width: "115px",
                                height: "115px",
                                display: "block",
                                position: "relative"
                              }}
                            >
                              <img
                                src={keys.ServicePath + item.StudentPhoto}
                                alt="logo"
                                className="printlogo-img"
                              />
                            </td>
                          ) : (
                            <td />
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan={2}
                    style={{
                      borderTop: "1px solid #444",
                      borderBottom: "1px solid #444",
                      padding: "2px"
                    }}
                  >
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td
                            align="left"
                            width="70%"
                            style={{ padding: "1px 2px" }}
                          >
                            <strong>Name :</strong>
                            &nbsp;
                            <span className="text-capitalize">
                              {item.StudentName ? item.StudentName : ""}
                            </span>
                          </td>
                          <td align="left" style={{ padding: "1px 2px" }}>
                            <strong
                              style={{
                                display: "inline-block",
                                width: 79
                              }}
                            >
                              Receipt No :
                            </strong>
                            <span>{item.ReceiptNo ? item.ReceiptNo : ""}</span>
                          </td>
                        </tr>
                        <tr>
                          <td
                            align="left"
                            style={{ padding: "1px 5px 1px 2px" }}
                          >
                            <strong>Program :</strong>
                            &nbsp;
                            <span className="text-capitalize">
                              {item.ProgramFullName ? item.ProgramFullName : ""}
                            </span>
                          </td>
                          <td align="left" style={{ padding: "1px 2px" }}>
                            <strong
                              style={{
                                display: "inline-block",
                                width: 103
                              }}
                            >
                              Application No :
                            </strong>
                            &nbsp;
                            <span>
                              {this.props.tuitionFeesAdmNo
                                ? this.props.tuitionFeesAdmNo
                                : ""}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td align="left" style={{ padding: "1px 2px" }}>
                            <strong>Semester : </strong>
                            <span>{item.SemName ? item.SemName : ""}</span>
                          </td>
                          <td align="left" style={{ padding: "1px 2px" }}>
                            <strong
                              style={{
                                display: "inline-block",
                                width: 97
                              }}
                            >
                              EnrollmentNo :
                            </strong>
                            <span>
                              {item.GR_EnrollmentNo ? item.GR_EnrollmentNo : ""}
                            </span>
                          </td>
                        </tr>

                        <tr>
                          <td align="left" style={{ padding: "1px 2px" }}>
                            <strong>Academic Year : </strong>
                            {item.AcYear}
                          </td>
                          <td align="left" style={{ padding: "1px 2px" }}>
                            <strong>Date : </strong>
                            {moment(item.TransactionDate).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <table
                      cellSpacing={1}
                      cellPadding={1}
                      border={0}
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        borderBottom: "1px solid #444"
                      }}
                      rules="all"
                    >
                      <tbody>
                        <tr>
                          <td align="center" style={{ padding: "2px" }}>
                            <strong>Sr No.</strong>
                          </td>
                          <td align="center" style={{ padding: "2px" }}>
                            <strong>Fees</strong>
                          </td>
                          <td align="right" style={{ padding: "2px" }}>
                            <strong>Amount (Rs/-)</strong>
                          </td>
                        </tr>
                        {item.feesList.map((data, index) => {
                          return (
                            <tr key={index}>
                              <td
                                align="center"
                                style={{
                                  width: 50,
                                  padding: "2px"
                                }}
                              >
                                {index + 1}
                              </td>
                              <td
                                className="text-capitalize"
                                align="left"
                                style={{
                                  width: "61%",
                                  padding: "2px"
                                }}
                              >
                                {data.FeesTypeName}
                              </td>
                              <td
                                align="right"
                                style={{
                                  width: 110,
                                  padding: "2px"
                                }}
                              >
                                {data.InstallmentWiseAmount}
                                /-
                              </td>
                            </tr>
                          );
                        })}

                        {parseInt(item.LateFees, 10) > 0 && (
                          <tr>
                            <td
                              align="center"
                              style={{
                                width: 50,
                                padding: "2px"
                              }}
                            >
                              {item.items.length + 1}
                            </td>
                            <td
                              align="left"
                              className="text-capitalize"
                              style={{
                                width: "61%",
                                padding: "2px"
                              }}
                            >
                              Late Fees
                            </td>
                            <td
                              align="right"
                              style={{
                                width: 110,
                                padding: "2px"
                              }}
                            >
                              {item.LateFees}/-
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td align="center" style={{ width: 50 }}>
                            &nbsp;
                          </td>
                          <td align="left" style={{ width: "61%" }} />
                          <td align="right" style={{ width: 110 }} />
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td
                    align="left"
                    valign="top"
                    width="55%"
                    style={{ padding: "4px" }}
                  >
                    <strong>Payment Mode :</strong>
                    &nbsp;
                    <span>{item.PaymentModeName}</span>
                    <br />
                    {item.PaymentModeId !== 6 && item.PaymentModeId !== 1 && (
                      <div>
                        <strong>Cheque No :</strong>
                        &nbsp;
                        <span className="text-capitalize">
                          {item.Chq_RefNo ? item.Chq_RefNo : ""}
                        </span>
                        <br />
                      </div>
                    )}
                    {item.PaymentModeId !== 6 && item.PaymentModeId !== 1 && (
                      <div>
                        <strong>Bank Detail :</strong>
                        &nbsp;
                        <span className="text-capitalize">
                          {item.BankName ? item.BankName : ""}
                        </span>
                      </div>
                    )}
                  </td>
                  <td align="right" style={{ padding: "4px" }} valign="top">
                    <strong style={{ display: "inline-block", width: 80 }}>
                      Total Fees :
                    </strong>
                    &nbsp;
                    <span
                      style={{
                        display: "inline-block",
                        width: 70,
                        textAlign: "right"
                      }}
                    >
                      {item.OrgWiseTotalPaidAmount
                        ? item.OrgWiseTotalPaidAmount
                        : "0.0"}
                      /-
                    </span>
                    <br />
                    <span style={{ display: "inline-block", width: 80 }}>
                      &nbsp;
                    </span>
                    &nbsp;
                    <span
                      style={{
                        display: "inline-block",
                        width: 70,
                        textAlign: "right"
                      }}
                    >
                      &nbsp;
                    </span>
                  </td>
                </tr>
                <tr>
                  <td
                    align="left"
                    style={{
                      border: "1px solid #444",
                      borderLeft: "0 solid #ffffff",
                      padding: "4px"
                    }}
                  >
                    <strong>In Words :</strong>&nbsp;
                    {item.OrgWiseTotalPaidAmount !== null && (
                      <span className="text-capitalize">
                        {numberToWord(item.OrgWiseTotalPaidAmount)}
                        Only
                      </span>
                    )}
                    &nbsp;
                  </td>
                  <td
                    style={{
                      border: "1px solid #444",
                      borderRight: "0 solid #ffffff",
                      padding: "1px 2px"
                    }}
                    align="right"
                  >
                    <strong style={{ display: "inline-block", width: 80 }}>
                      Amount :
                    </strong>
                    &nbsp;
                    <span
                      style={{
                        display: "inline-block",
                        width: 70,
                        textAlign: "right"
                      }}
                    >
                      {item.OrgWiseTotalPaidAmount
                        ? item.OrgWiseTotalPaidAmount
                        : "0.0"}
                      /-
                    </span>
                  </td>
                </tr>
                <tr>
                  <td align="left" style={{ height: 50, padding: "1px 2px" }}>
                    <div
                      style={{
                        height: 57,
                        // border: "1px solid #444",
                        margin: 2
                      }}
                    >
                      <strong>Remarks :</strong>
                      &nbsp;
                      <span>{item.Remarks ? item.Remarks : ""}</span>
                    </div>
                  </td>
                  <td align="center" style={{ height: 50, padding: "1px 2px" }}>
                    <strong>Authorized Signatory,</strong>
                    <br />
                    <br />
                    <span>__________________</span>
                  </td>
                </tr>
              </tbody>
            </table>
          );
        })}
      </div>
    );
  }
}
function mapStateToProps({ auth }) {
  return {
    auth
  };
}
export default connect(
  mapStateToProps,
  { actions }
)(TuitionFeesReceipt);



// WEBPACK FOOTER //
// ./src/components/StudentAccount/TuitionFeesReceipt.js